import { diffPatch } from '@kit/sync/merge/diff-patch';
import { replica } from '@/shared/sync/replica';
import { cleanData } from './clean-data';
import type { CollectionName } from './collection-name';
import type { RecordSchema } from './record-schema';
import { validateRecord } from './validate-record';

/** Save the whole edited record; only the fields that changed are sent. */
export async function saveRecord(
  collection: CollectionName,
  schema: RecordSchema,
  id: string,
  data: Readonly<Record<string, unknown>>,
): Promise<void> {
  const current = await replica.get(id);
  if (!current) throw new Error('The record no longer exists');
  const patch = diffPatch(current.data, validateRecord(schema, cleanData(data)));
  if (Object.keys(patch).length > 0) await replica.mutate(collection, 'upsert', patch, id);
}
